import { FC } from "react";
import { Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { MoneyCellRenderer } from "./MoneyCellRenderer";

interface MoneyWithTooltipCellRendererProps {
  approximate?: boolean;
  money: number | null;
  billable?: string;
  tooltip: string;
}

export const MoneyWithTooltipCellRenderer: FC<
  MoneyWithTooltipCellRendererProps
> = ({ money, tooltip, billable, approximate }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="body2" component="div">
        <MoneyCellRenderer
          approximate={approximate}
          money={money}
          billable={billable}
        />
      </Typography>

      {tooltip && (
        <Tooltip title={tooltip} placement="top" arrow>
          <InfoOutlinedIcon color="action" fontSize="small" />
        </Tooltip>
      )}
    </Stack>
  );
};
